<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{path: 'RechargeList'}">{{ $t('common.home') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('recharge.rechargeLog') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('recharge.userRechargeLog') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="4" class="display-row">
            <div class="query-title">{{ $t('common.createStartDate') }}:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :placeholder="$t('common.selectDate')"></el-date-picker>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">{{ $t('common.createEndDate') }}:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :placeholder="$t('common.selectDate')"></el-date-picker>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title" style="text-align: right">{{ $t('recharge.tradeNo') }}</div>
            <div class="flex1">
              <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.tradingNo" size="small"
                @keyup.enter.native="searchList"></el-input>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title" style="text-align: right">{{ $t('recharge.rechargeType') }}</div>
            <div class="flex1">
              <el-select size="small" v-model="queryInfo.rechargeType" :placeholder="$t('common.pleaseSelect')">
                <el-option v-for="(item, index) in rechargeTypeOptions" :key="index" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title" style="text-align: right">{{ $t('recharge.payUser') }}</div>
            <div class="flex1">
              <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.drawee" size="small"
                @keyup.enter.native="searchList"></el-input>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title" style="text-align: right">{{ $t('recharge.payAccount') }}</div>
            <div class="flex1">
              <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.bankNo" size="small"
                @keyup.enter.native="searchList"></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 0}"
              @click="quickSearchList('', (index = 0))">{{ $t('common.all') }}</el-button>
            <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 1}"
              @click="quickSearchList('0', (index = 1))">
              {{ $t('recharge.auditing') }}
              <span class="lx-red">({{ orderData.checkingNum }})</span>
            </el-button>
            <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 2}"
              @click="quickSearchList('1', (index = 2))">{{ $t('recharge.rechargeSuccess') }}</el-button>
            <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 3}"
              @click="quickSearchList('2', (index = 3))">{{ $t('recharge.rechargeFailed') }}</el-button>
            <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 4}"
              @click="quickSearchList('3', (index = 4))">{{ $t('recharge.cancelled') }}</el-button>
          </el-col>
          <el-col :span="18" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px; floate: right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">{{ $t('common.reset') }}</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">{{ $t('common.search') }}</el-button>
              <el-button class="search-btn btn-blue" @click="toRechargeMoney">{{ $t('recharge.recharge') }}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col" style="padding: 10px">
        <el-table :data="recordList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" border
          height="550">
          <el-table-column type="index" align="center" :label="$t('wzbg.wz6')" width="60"></el-table-column>
          <el-table-column align="center" :label="$t('recharge.orderOpr')" width="110">
            <template v-slot="scope">
              <div class="btn-row" v-if="['0'].indexOf(scope.row.rechargeStatus) > -1">
                <el-button class="list-btn btn-deepblue" @click="sendAction(scope.row)">{{ $t('common.cancel') }}</el-button>
              </div>
              <div class="btn-row" v-if="['1'].indexOf(scope.row.rechargeStatus) > -1">
                <el-button class="list-btn btn-deepblue" @click="handleOpen(scope.row)">{{ $t('recharge.export') }}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="tradingNo" :label="$t('recharge.tradeNo')"></el-table-column>
          <el-table-column align="center" prop="createTime" :label="$t('common.createDate')">
            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToDay }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="rechargeStatus" :label="$t('recharge.rechargeState')">
            <template v-slot="scope">
              {{ rechargeStatusShow(scope.row.rechargeStatus) }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="rechargeType" :label="$t('recharge.rechargeType')">
            <template v-slot="scope">
              {{ typeDetailShow(scope.row.rechargeType) }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="drawee" :label="$t('recharge.payUser')"></el-table-column>
          <el-table-column align="center" prop="bankNo" :label="$t('recharge.payAccount')"></el-table-column>
          <el-table-column align="center" prop="payTime" :label="$t('recharge.payDate')">
            <template v-slot="scope">
              {{ scope.row.payTime | dateFormatToDay }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="moneyJpy" :label="$t('recharge.zcladd06')"></el-table-column>
          <el-table-column align="center" prop="handlingFeeJpy" :label="$t('recharge.zcladd07')"></el-table-column>
          <el-table-column align="center" prop="paypalFeeJpy" :label="$t('recharge.zcladd02')"></el-table-column>
          <el-table-column align="center" prop="exchangeRate" :label="$t('recharge.exchangeRate')"></el-table-column>
          <el-table-column align="center" prop="money" :label="$t('recharge.zcladd01')"></el-table-column>

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100]" :pager-count="5" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </table-con>
    <el-dialog :visible.sync="openDialog" width="600px" @close="openDialog=false">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
        <p class="tips">{{$t('recharge.queren')}}</p>
        <el-form-item prop="realName" :label="$t('address.address19')">
          <el-input v-model="ruleForm.realName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="openDialog=false">{{ $t('cancel') }}</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">{{ $t('confirm') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer';
import axios from "axios";
export default {
  components: { tableCon },
  data () {
    return {
      curIndex: 0, // 默认选中第0个
      rechargeTypeOptions: [
        {
          name: this.$t('recharge.bankTransfer'),
          value: '2'
        }
      ],
      openDialog: false,
      queryInfo: {
        rechargeNo: '',
        tradingNo: '',
        createTimeStart: '',
        createTimeEnd: '',
        rechargeStatus: '',
        pageSize: 10,
        pageNum: 1,
      },
      id: "",
      tradingNo: "",
      orderData: {
        checkingNum: 0,
      },
      ruleForm: {
        realName: ""
      },
      name: "",
      rules: {
        realName: [{ required: true, message: this.$t('common.pleaseInput'), trigger: 'blur' }],
      },
      orderDateRangeValue: [],
      recordList: [],
      total: 0,
      orderDetailValue: {
        id: '',
        rechargeStatus: '',
      },
    };
  },
  methods: {
    getUserName () {
      this.$http
        .get('payRecord/queryRealName', this.chargeForm)
        .then((res) => {
          this.name = res.data.data
        })
        .catch((res) => {
          console.log(res);
        });
    },
    handleOpen (row) {
      this.id = row.id
      this.tradingNo = row.tradingNo
      this.openDialog = true
      this.ruleForm.realName = this.name
    },
    submitForm (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let obj = {
            id: this.id,
            realName: this.ruleForm.realName
          }
          axios({
            method: "POST",
            url: `payRecord/pdf`,
            data: obj,
            headers: {
              'Authorization': window.sessionStorage.getItem('token')
            },
            responseType: 'blob'
          }).then((res) => {
            console.log(res)
            const blob = new Blob([res.data], {
              // 下载的文件格式自己在这边更改type的值就好了
              type: 'application/pdf;charset=utf-8'
            })
            if ('download' in document.createElement('a')) {
              const elink = document.createElement('a')
              elink.download = `御請求書${this.tradingNo}.pdf`
              elink.style.display = 'none'
              elink.href = URL.createObjectURL(blob)
              document.body.appendChild(elink)
              elink.click()
              URL.revokeObjectURL(elink.href)
              document.body.removeChild(elink)
              this.openDialog = false
            }

          })
            .catch((res) => {
              console.log(res)
            });
        } else {
          return false;
        }
      });
    },
    //正常发送
    sendAction (row) {
      this.sendDeal(row);
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    orderDateRange () { },
    searchList () {
      //查询
      console.log(this.queryInfo);
      this.queryInfo.pageNum = 1;
      this.getrecordList();
      this.getStatisticalNum();
    },
    quickSearchList (val, index) {
      this.curIndex = index;
      this.queryInfo.pageNum = 1;
      this.queryInfo.rechargeStatus = val;
      this.getrecordList();
      this.getStatisticalNum();
    },
    toRechargeMoney (row) {
      this.$router.push({
        name: 'recharge',
        query: {
          id: row.id,
        },
      });
    },
    async getrecordList () {
      console.log(this.queryInfo);
      const { data: res } = await this.$http.get('/payRecord/list', { params: this.queryInfo });
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    async getStatisticalNum () {
      //获取
      const { data: res } = await this.$http.get('/payRecord/getStatisticalNum', { params: this.queryInfo });
      this.orderData = res.data;
    },
    sendDeal (row) {
      this.$confirm(this.$t('recharge.cancelRechargeConfirm'), '', {
        confirmButtonText: this.$t('common.submit'),
        confirmButtonClass: 'form-btn btn-blue',
        cancelButtonText: this.$t('common.cancel'),
        cancelButtonClass: 'form-btn btn-gray',
        type: 'warning',
      }).then(async () => {
        this.orderDetailValue.id = row.id;
        this.orderDetailValue.rechargeStatus = '3';
        const { data: res } = await this.$http.post(`payRecord/updateAction/`, this.orderDetailValue);
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: 'success',
            message: this.$t('common.submitSuccess'),
          });
          await this.getrecordList();
          this.getStatisticalNum();
        }
      });
    },
    queryInfoClear () {
      //清空
      this.queryInfo = {
        createTimeStart: '',
        createTimeEnd: '',
        rechargeNo: '',
        pageSize: 10,
        pageNum: 1,
      };
      this.orderDateRangeValue = [];
    },
    rechargeStatusShow (status) {
      switch (status) {
        case '0':
          return this.$t('recharge.auditing');
        case '1':
          return this.$t('recharge.rechargeSuccess');
        case '2':
          return this.$t('recharge.rechargeFailed');
        case '3':
          return this.$t('recharge.cancelled');
      }
    },
    typeDetailShow (status) {
      switch (status) {
        case '0':
          return this.$t('recharge.wechat');
        case '1':
          return this.$t('recharge.alipay');
        case '2':
          return this.$t('recharge.bankTransfer');
        case '3':
          return this.$t('recharge.paypal');
      }
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    orderDateRangeValue () {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.orderDateRangeValue) {
        this.orderDateRangeValue = [];
        this.queryInfo.createTimeStart = '';
        this.queryInfo.createTimeEnd = '';
      } else {
        if (this.orderDateRangeValue.length > 0) {
          this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
          this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
        }
      }
    },
  },
  created () {
    this.queryInfo.rechargeNo = this.$route.query.rechargeNo;
    this.getStatisticalNum();
    this.getrecordList();
    this.getUserName()
  },
};
</script>

<style lang="less" scoped>
.tips {
  font-size: 16px;
  padding-left: 55px;
  margin-bottom: 20px;
}
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
</style>
